import React, { useCallback, useMemo, useState } from 'react';
import { Tooltip } from 'src/components/ui';
import { useDarkMode } from '../context/DarkModeContext';
import Icon from 'src/components/Icon';

function Help({ children }) {
  // eslint-disable-next-line no-plusplus
  const id = useMemo(() => `help-${Help.__ct__++}`, []);
  const [isOpen, setOpen] = useState(false);
  const toggle = useCallback(() => setOpen(!isOpen), [isOpen]);
  const { isDarkMode } = useDarkMode();

  return (
    <>
      <Icon icon="Info" id={id}  style={{ color: isDarkMode ? '#6ec3f4' : '#33ccff' }} />
      <Tooltip target={id} toggle={toggle} isOpen={isOpen} fade={false}>
        {children}
      </Tooltip>
    </>
  );
}

Help.__ct__ = 0;

export default Help;
